const faqItems = [
  {
    q: '酷看漫画是免费的吗？',
    a: '是的，酷看漫画所有内容完全免费，无需付费订阅或购买会员。我们将韩漫、日漫、国漫分类整理，读者可以自由浏览全部漫画资源。',
  },
  {
    q: '多久更新一次漫画内容？',
    a: '酷看漫画每日更新数百话最新漫画内容。热门连载作品保持与官方同步的更新频率，让追更读者第一时间看到最新章节。',
  },
  {
    q: '支持哪些类型的漫画？',
    a: '平台覆盖玄幻修仙、恋爱甜宠、热血战斗、悬疑推理、搞笑日常、穿越重生等多种热门类型，韩漫、日漫、国漫分类齐全，满足不同读者的喜好。',
  },
  {
    q: '手机和平板可以看漫画吗？',
    a: '完全可以。酷看漫画针对手机和平板进行了专门适配，支持横屏和竖屏自由切换，阅读体验流畅舒适。随时随地打开浏览器即可阅读。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '可以通过首页的专题合集、排行榜和分类标签快速定位感兴趣的漫画。也可以使用搜索功能，输入漫画名称或类型关键词，一搜即达。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于酷看漫画的一些常见疑问解答</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="rounded-xl bg-background-100 p-5">
              <h3 className="text-sm font-bold text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q:</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}